// removed by extract-text-webpack-plugin
module.exports = {"notifications":"_2cp7-"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/notifications-page/notifications-page.scss
// module id = 1667
// module chunks = 0